export var opacities = {
    light12: 0.12,
    light24: 0.24,
    light38: 0.38,
    halfOpacity: 0.5,
    dark70: 0.7,
    dark87: 0.87,
    noOpacity: 1.0,
    rgbaLight04: 'rgba(0, 0, 0, 0.04)',
    rgbaLight08: 'rgba(0, 0, 0, 0.08)',
    rgbaLight15: 'rgba(0, 0, 0, 0.15)',
    rgbaLight10: 'rgba(0, 0, 0, 0.1)',
    rgbaHalfOpacity: 'rgba(0, 0, 0, 0.5)'
};
/**
 * all font-sizes should be in pixel values
 */
export var fontSizes = {
    xsmall: 12,
    small: 14,
    root: 16,
    medium: 20,
    large: 24,
    xLarge: 28,
    xxLarge: 32,
    xxxLarge: 44
};
export var lineHeights = {
    root: 1.5,
    large: 1.57,
    larger: 1.6,
    largest: 1.67
};
export var fontWeights = {
    light: 300,
    regular: 400,
    semiBold: 600,
    bold: 700,
    extraBold: 800
};
export var colors = {
    black: '#333333',
    boulder: '#757575',
    alto: '#DBDBDB',
    error: '#9E2A20',
    success: '#3E8529',
    warning: '#caa416',
    info: '#0072AD',
    darkBlue: '#34657F',
    divider: '#dfdfdf',
    white: '#FFFFFF',
    lighterGrey: '#f4f4f4',
    lightestGrey: '#F6F6F6',
    lightGrey: '#E0E0E0',
    heavyGrey: '#9E9E9E',
    mediumGrey: '#656565',
    grey: '#cdcdcd',
    lightBlue: '#e5f6ff',
    mercury: '#e2e2e2',
    wildSand: '#f5f5f5',
    doveGray: '#666666',
    tuna: '#3b3c43',
    trout: '#525862',
    nobel: '#b3b3b3',
    cadetBlue: '#9EB5C2',
    havelockBlue: '#5B9DD9',
    aquaSpring: '#EEF7FA',
    warningText: '#8a6c00',
    darkCyanBlue: '#34657F',
    darkGray: ' #3B3C39',
    slateGray: '#9ab2bf',
    cadetGray: '#F0F3F5',
    lightGreen: '#E7F6E3',
    darkGreen: '#67AC53'
};
export var theme = {
    body: 'transparent',
    bodyText: '#333333',
    link: '#34657F',
    icon: '#cacaca',
    termsAndConditions: {
        text: '#ffffff',
        link: '#ffffff'
    },
    accordion: {
        borderColor: '#e2e2e2',
        headerBackgroundColor: '#ffffff',
        activeHeaderBackgroundColor: '#ffffff'
    },
    binart: {
        background: '#34657F',
        disableBackground: 'rgba(0, 0, 0, 0.08)',
        disableBorderColor: 'rgba(0, 0, 0, 0.5)' // using rgba for IE to work
    },
    chipIcon: {
        borderShadowLight: 'rgba(0,0,0,0.01)',
        borderShadowMedium: 'rgba(0,0,0,0.04)'
    },
    button: {
        primary: {
            text: '#FFFFFF',
            hover: '#244759'
        },
        secondary: {
            hover: '#d9d9d9'
        },
        text: '#34657F',
        ghost: '#34657F',
        background: '#34657F'
    },
    field: {
        icon: '#cacaca',
        focus: '#34657F',
        label: '#656565'
    },
    checkbox: {
        background: '#34657F',
        font: '#FFFFFF'
    },
    chip: {
        hover: '#ffe5ad',
        text: '#34657F'
    },
    switch: {
        background: '#34657F'
    },
    radio: {
        border: '#34657F',
        background: '#34657F',
        inactiveBorder: '#656565',
        focusBackground: '#CECFD1'
    },
    navigation: {
        activeTabText: '#1977D3',
        activeTabBorder: '#34657F',
        dropdownHover: '#E8F1FB'
    },
    datepicker: {
        dueDate: '#1977D3',
        selectedDate: '#1977D3',
        selectedDateText: '#FFFFFF'
    },
    tooltip: {
        borderColor: '#d8d8d8',
        backgroundColor: '#ffffff',
        color: '#3b3c43'
    },
    headerDivider: '#FFFFFF',
    footerDivider: 'rgba(0, 0, 0, 0.15)',
    footer: {
        background: '#FFF',
        text: '#333333',
        border: ''
    },
    header: {
        background: '#FFF',
        text: '',
        border: '#FFF',
        logoWidth: '320px'
    },
    cobrowse: '#333333',
    loader: '#1977D3',
    progressStepBar: {
        fill: '#cacaca',
        label: '#cacaca'
    },
    toasts: {
        warning: {
            font: '#C66400',
            icon: '#FF8F1C',
            iconBackground: '#C66400',
            background: '#FFF4E8'
        },
        success: {
            font: '#008A00',
            icon: '#006100',
            iconBackground: '#008A00',
            background: '#E6F3E6'
        },
        info: {
            font: '#1977D3',
            icon: '#145FA9',
            iconBackground: '#1977D3',
            background: '#E8F1FB'
        },
        error: {
            font: '#C63527',
            icon: '#8B251B',
            iconBackground: '#C63527',
            background: '#FFEFEF'
        }
    },
    notificationBar: {
        success: {
            icon: '#FFFFFF',
            iconBackground: '#3E8529',
            background: '#E7F6E3',
            border: '#67AC53'
        },
        error: {
            icon: '#9E2A20',
            iconBackground: '#FFFFFF',
            background: '#FCF4F3',
            border: '#CC3F33'
        }
    },
    tag: {
        scheduled: {
            icon: '#1977D3',
            background: '#E8F1FB'
        },
        processingCharged: {
            icon: '#333333',
            background: '#F4F4F4'
        },
        posted: {
            icon: '#008A00',
            background: '#E6F3E6'
        },
        canceled: {
            icon: '#C63527',
            background: '#FAE4E1'
        },
        rejected: {
            icon: '#FF8F1C',
            background: '#FFF4E8'
        },
        defaultColors: {
            background: ' #F4F4F4',
            icon: '#333333'
        }
    },
    messageBox: {
        warning: {
            border: '#f0d675',
            icon: '#caa416',
            font: '#333333',
            background: '#fffaeb'
        },
        success: {
            border: '#008A00',
            icon: '#008A00',
            font: '#333333',
            background: '#E6F3E6'
        },
        info: {
            border: '#1977D3',
            icon: '#1977D3',
            font: '#333333',
            background: '#E8F1FB'
        },
        error: {
            border: '#C63527',
            icon: '#C63527',
            font: '#333333',
            background: '#FFEFEF'
        }
    },
    messaging: {
        warning: {
            font: '#FF8F1C',
            background: '#FFF4E8'
        },
        success: {
            font: '#008A00',
            background: '#E6F3E6'
        },
        info: {
            font: '#1977D3',
            background: '#E8F1FB'
        },
        error: {
            font: '#C63527',
            background: '#FFEFEF'
        }
    },
    systemNavigation: {
        background: '#FFFFFF',
        icon: '#333333',
        text: '#333333',
        dropdownHover: '#E8F1FB'
    },
    alertBar: {
        warning: {
            font: '#333333',
            background: '#FF8F1C'
        },
        success: {
            font: '#333333',
            background: '#E6F3E6'
        },
        info: {
            font: '#333333',
            background: '#A4DBE8'
        },
        default: {
            font: '#333333',
            background: '#F4F4F4'
        },
        error: {
            font: '#333333',
            background: '#FFEFEF'
        }
    },
    dataTable: {
        hover: '#f7fafc'
    }
};
export default theme;
